export class CustomNoRowsOverlay {
  eGui: HTMLElement;

  init(params) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = params.innerText;
    if (params.clickable === 'true') {
      this.eGui.classList.add('no-data-overlay-link');
      this.eGui.addEventListener('click', () => {
        params.callback();
      });
    } else {
      this.eGui.classList.add('no-project-to-show');
    }
  }

  getGui() {
    return this.eGui;
  }
}
